// ============================================================
// The build panel's settings - plain state, no terrain.
//
// Three groups, one hook each, so useBattlefieldBuild can compose them
// and each stays readable: what the tools do (tool, level, layers,
// stacking, the wheel, the zone's name), how a drag becomes a footprint
// (gesture and shape), and what the Shape tool places next.
// ============================================================
import { useState } from 'react';

/** Which tool is up and the level and depth it works at. */
export function useBuildSettings() {
  const [tool, setTool] = useState('fill');
  const [level, setLevel] = useState(0);
  const [layers, setLayers] = useState(1);
  const [autoStack, setAutoStack] = useState(true);
  /**
   * What the wheel does while a build drag is live.
   *
   * Growing the VOLUME is the default, because a circle should become a
   * cylinder. Lifting the slab instead is how you build a gantry, which
   * is worth having and is not what anyone means most of the time.
   */
  const [floatMode, setFloatMode] = useState(false);
  const [zoneLabel, setZoneLabel] = useState('');
  return {
    tool,
    setTool,
    level,
    setLevel,
    layers,
    setLayers,
    autoStack,
    setAutoStack,
    floatMode,
    setFloatMode,
    zoneLabel,
    setZoneLabel,
  };
}

/**
 * How a drag turns into a footprint. All of them are inert until used, so
 * the plain rectangle everyone already knows is still one drag away.
 */
export function useGestureOptions() {
  const [gesture, setGesture] = useState('rect');
  const [brushSize, setBrushSize] = useState(1);
  const [shape, setShape] = useState('rect');
  const [sides, setSides] = useState(6);
  const [hollow, setHollow] = useState(false);
  const [tip, setTip] = useState('square');
  const [thickness, setThickness] = useState(1);
  return {
    gesture,
    setGesture,
    brushSize,
    setBrushSize,
    shape,
    setShape,
    sides,
    setSides,
    hollow,
    setHollow,
    tip,
    setTip,
    thickness,
    setThickness,
  };
}

/** The Shape tool: what the next structure will be, and how big. */
export function useStructureOptions() {
  const [structureShape, setStructureShape] = useState('cylinder');
  const [structureRadius, setStructureRadius] = useState(1);
  const [structureHeight, setStructureHeight] = useState(3);
  const [structureRotation, setStructureRotation] = useState(0);
  return {
    structureShape,
    setStructureShape,
    structureRadius,
    setStructureRadius,
    structureHeight,
    setStructureHeight,
    structureRotation,
    setStructureRotation,
  };
}
